import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const PhotoReferencesSkeleton: React.FC = () => (
  <div className="space-y-2">
    <Skeleton className="h-4 w-40" />
    <Skeleton className="h-4 w-40" />
  </div>
)

export default PhotoReferencesSkeleton
